import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import StyleSetting from './components/StyleSetting';

const { Cell } = ResponsiveGrid;

const CommunityFrontDeskStyle = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="社區前台畫面"
        breadcrumbs={[
          {
            name: '社區管理',
          },
          {
            name: '社區前台畫面',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <StyleSetting />
    </Cell>
  </ResponsiveGrid>
);

export default CommunityFrontDeskStyle;
